module.exports = __webpack_public_path__ + "components/flag/static/square/pf-0629754d6ae39e3b747383fcaa8e1bd6.svg";